module.exports = __webpack_public_path__ + "img/box-sessions.706410bd.png";